import React, { useState } from "react";
import { Link } from "react-router-dom";

const TopBar = () => {
    const [isLanguageOpen, setLanguageOpen] = useState(false);
    const [isCurrencyOpen, setCurrencyOpen] = useState(false);

    const handleLanguageSelect = () => {
        setLanguageOpen(false);
    };

    const handleCurrencySelect = () => {
        setCurrencyOpen(false);
    };

    return (
        <div>
            <div id="top-bar-one" className="top-bar-main-block-one text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <ul className="top-bar-dtls">
                                <li>
                                    <Link to="#" title="Track Order">Track Order</Link>
                                </li>
                                <li>
                                    <Link to="#" title="About Us">About Us</Link>
                                </li>
                                <li>
                                    <Link to="#" title="Contact">Contact</Link>
                                </li>
                                <li>
                                    <Link to="#" title="FAQ">FAQ</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-8 col-md-8">
                            <ul className="top-bar-info-block">
                                <li>
                                    <Link to="#" className="contact" title="Contact Us">
                                        <i className="flaticon-phone"></i> You can contact us 24/7
                                        <span>0 800 300-353</span>
                                    </Link>
                                </li>
                                <li className="dropdown top-bar-dropdown">
                                    <button
                                        className="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        onClick={() => setLanguageOpen(!isLanguageOpen)}
                                    >
                                        English <i className="flaticon-down-arrow" />
                                    </button>
                                    {isLanguageOpen && (
                                        <ul className="dropdown-menu show">
                                            <li><Link className="dropdown-item" to="#" onClick={handleLanguageSelect}>English</Link></li>
                                            <li><Link className="dropdown-item" to="#" onClick={handleLanguageSelect}>Hindi</Link></li>
                                            <li><Link className="dropdown-item" to="#" onClick={handleLanguageSelect}>French</Link></li>
                                            <li><Link className="dropdown-item" to="#" onClick={handleLanguageSelect}>Arabic</Link></li>
                                        </ul>
                                    )}
                                </li>
                                <li className="dropdown top-bar-dropdown">
                                    <button
                                        className="btn btn-secondary dropdown-toggle"
                                        type="button"
                                        onClick={() => setCurrencyOpen(!isCurrencyOpen)}
                                    >
                                        USD <i className="flaticon-down-arrow" />
                                    </button>
                                    {isCurrencyOpen && (
                                        <ul className="dropdown-menu show">
                                            <li><Link className="dropdown-item" to="#" onClick={handleCurrencySelect}>USD</Link></li>
                                            <li><Link className="dropdown-item" to="#" onClick={handleCurrencySelect}>INR</Link></li>
                                            <li><Link className="dropdown-item" to="#" onClick={handleCurrencySelect}>EUR</Link></li>
                                            <li><Link className="dropdown-item" to="#" onClick={handleCurrencySelect}>MYR</Link></li>
                                        </ul>
                                    )}
                                </li>
                                <li className="dark-mode">
                                    <i className="flaticon-brightness"></i> Dark Theme
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopBar;
